module.exports = __webpack_public_path__ + "img/special_battleRoyale.a329bd56.png";